import { render, staticRenderFns } from "./SelectKnowleageQuestionModal.vue?vue&type=template&id=15ce2021"
import script from "./SelectKnowleageQuestionModal.vue?vue&type=script&lang=js"
export * from "./SelectKnowleageQuestionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports